import useSWR from "swr";
import useSWRMutation from "swr/mutation";
import axiosInstance from "Api";

// GET Fetcher
const fetcher = async (arg) => {
   
    try {
        
        if (typeof arg === "string") {
            const response = await axiosInstance.get(arg);
            return response.data;
        }

        const [url, params] = arg;

        const response = await axiosInstance.get(url, {
            params: params || {},
        });

        return response.data;
    } catch (error) {
        throw error?.response?.data || error;
    }
};

// POST/PUT/PATCH/DELETE Fetcher
const mutationFetcher = async (key, { arg }) => {
    try {
        const requestConfig = {
            url: arg?.url || key?.url || key,
            method:
                arg?.method ||
                key?.method ||
                "post",
            data: arg?.data,
            params: arg?.params,
        };

        const response = await axiosInstance(requestConfig);
        return response?.data;
    } catch (error) {
        throw error?.response?.data || error;
    }
};

// Generic GET Hook
export const useApi = (url, config = {}) => {
    const { data, error, isLoading,isValidating, mutate } = useSWR(
        url || null,
        fetcher,
        config
    );

    return {
        data,
        error,
        isLoading,
        isValidating,
        mutate,
    };
};

// Generic Mutation Hook
export const useApiMutation = (url = "mutation") => {
    const mutation = useSWRMutation(
        url,
        mutationFetcher
    );

    return {
        trigger: mutation.trigger,
        data: mutation.data,
        error: mutation.error,
        isMutating: mutation.isMutating,
        reset: mutation.reset,
    };
};

// Combined Hook
export const useApiFetcherSWR = (api, config = {}) => {

    const isValid = api?.url && api?.method;
    const isGet = api?.method?.toLowerCase() === "get";

    const swr = useSWR(
        
        isValid && isGet
            ? [api.url, api.params]   // NEW support
            : null,
        fetcher,
        config
    );

     

    // IMPORTANT:
    // Pass full api object, not api.url
    const mutation = useSWRMutation(
        isValid && !isGet ? api : null,
        mutationFetcher
    );

    return {
        data: isGet ? swr.data : mutation.data,
        error: isGet ? swr.error : mutation.error,
        isLoading: isGet ? swr.isLoading : false,
        isValidating: isGet ? swr.isValidating : false,
        isMutating: mutation.isMutating,
        mutate: swr.mutate,
        trigger: mutation.trigger,
        reset: mutation.reset,
    };
};